import React, { useState } from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';

import BaseSemanticLink from '@base/BaseSemanticLink';
import Result from '@pages/tools/link-checker/Result';
import Form from '@pages/tools/link-checker/Form';

import externalLinks from '@config/external-links.json';
import useI18n, { getLocalePaths } from '@i18n';
import { ResultTypes } from '@pages/tools/link-checker/index.d';

// HOCs
import WithRole, { rolesEnum } from '@HOCs/WithRole';

const LinkCheckerPage: React.FC = () => {
    const { t } = useI18n('LinkChecker');
    const [result, setResult] = useState({});
    const [submitError, setSubmitError] = useState(false);

    return (
        <div className="pb-40">
            <div className="mb-[16px] xs:mb-[24px]">
                <h2 className="font-medium text-blueGray-600 text-sub xs:text-h2">
                    {t('Link Checker')}
                </h2>
            </div>

            {/* Описание чекера ссылок */}
            <div className="mb-[16px] xs:mb-[24px] text-blueGray-800 text-[14px]">
                <p className="mb-[16px]">
                    {t(
                        'Link Checker will let you know whether the AliExpress product is affiliate or not',
                    )}
                </p>
                <p className="mb-[16px]">{t('Affiliate product is')}</p>
                <p className="mb-[16px]">{t('Non-affiliate product is')}</p>
                <p className="mb-[16px]">{t('Please note that the affiliate commission')}</p>
            </div>

            {/* Форма для ввода ссылок */}
            <Form setSubmitError={setSubmitError} setResult={setResult} />

            {/* Сообщение об ошибке во время проверки */}
            {submitError && (
                <div
                    id="LinkCheckerSubmitErrorBlock"
                    className="p-6 text-white bg-red-400 mt-[8px] rounded-2"
                >
                    <p className="font-medium">
                        {t('Error while checking links')}
                        <BaseSemanticLink
                            className="underline"
                            id="LinkCheckerResultSupportLink"
                            to={`mailto: ${externalLinks.mail}`}
                        >
                            {externalLinks.mail}
                        </BaseSemanticLink>
                    </p>
                </div>
            )}

            {/* Результаты */}
            <div className="mb-[16px] xs:mb-[24px] space-y-8 mt-[24px] xs:mt-[0px]">
                {Object.keys(result).map((type: ResultTypes) => (
                    <Result key={type} type={type} data={result[type]} />
                ))}
            </div>
        </div>
    );
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: getLocalePaths(), fallback: false };
};

export default WithRole(LinkCheckerPage, [rolesEnum.user]);
